import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-6 md:px-12 bg-sage/10" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-[2rem] shadow-xl relative" data-id="element-158">
          <div className="absolute -top-6 -left-6 bg-coral text-white p-4 rounded-full shadow-lg" data-id="element-159">
            <Sparkles size={32} data-id="element-160" />
          </div>

          <h3 className="text-2xl md:text-3xl font-serif font-bold text-charcoal mb-6 text-center" data-id="element-161">
            El cambio en 7 días
          </h3>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed text-center italic" data-id="element-162">
            "No verás una transformación mágica en la balanza de inmediato, pero
            notarás que tu rostro se desinflama, tus niveles de energía se
            estabilizan durante la tarde y, por primera vez en años, te
            despertarás sintiéndote descansada antes de que suene la alarma."
          </p>
        </motion.div>
      </div>
    </section>;
}